import Gravity from 'Gravity';

const contactUsFromInit = () => {
  if (!document.querySelector('.gg-contact-us-form')) {
    return;
  }



  const isFirefox = navigator.userAgent.match(/firefox|fxios/i);
  const refreshButtons = document.querySelectorAll('.gg-refresh-button');

  [...document.querySelectorAll('.ginput_container_select')].forEach((wrapper) => {
    const select = wrapper.querySelector('select');

    select.addEventListener('click', () => wrapper.classList.toggle('active'));

    select.addEventListener('keydown', (e) => {
      const keyCode = e.which.toString();

      if (keyCode === '13' && isFirefox) {
        return;
      }

      if (keyCode.match(/13|32/)) {
        wrapper.classList.toggle('active', !wrapper.classList.contains('active'));
      }
    });

    if (!isFirefox) {
      select.addEventListener('change', (e) => {
        e.target.blur();
        wrapper.classList.toggle('active');
      });
    }

    wrapper.addEventListener('focusout', () => wrapper.classList.remove('active'));
  });

  function refreshLocation() {
    window.location.reload();
  }

  refreshButtons.forEach((button) => {
    Gravity.clickEnterListener(button, refreshLocation);
  });
};
Gravity.ready(contactUsFromInit);
